import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import { AutoComplete, IconButton } from 'material-ui';
import ClearIcon from 'material-ui/svg-icons/content/clear';
import fetcher from '../helpers/fetcher';
import { URL_PROJECTS } from '../constants';

class ProjectSelector extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      projects: [],
      text: ''
    };
  }
  componentDidMount() {
    this._loadData();
  }

  _loadData = filterStr => {
    this.setState({ loading: true });
    fetcher
      .get(
        URL_PROJECTS +
          (filterStr
            ? `?where=${encodeURIComponent(
                `{"name":{"like":"%${filterStr}%"}}`
              )}`
            : '')
      )
      .then(res => {
        const projects = get(res, 'data.data', []);
        this.setState({
          projects,
          loading: false
        });
      });
  };

  _handleChange = (data, index) => {
    if (this.props.onSelect) {
      this.props.onSelect(data, index);
    }
    const { value, text } = data || {};
    if (this.props.onChange && value && value > -1) {
      this.props.onChange(value);
    }
    this.setState({
      text
    });
  };
  _handleTextChange = value => {
    this._loadData(value);
    this.setState({
      text: value
    });
  };

  _onClear = () => {
    this._loadData('');
    this.setState({
      text: ''
    });
  };

  render() {
    return (
      <div>
        <AutoComplete
          hintText="Select project to preview call screen"
          value={this.props.value}
          searchText={this.state.text}
          openOnFocus={true}
          anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
          targetOrigin={{ horizontal: 'left', vertical: 'top' }}
          listStyle={{
            width: 'auto'
          }}
          filter={AutoComplete.noFilter}
          onNewRequest={this._handleChange}
          onUpdateInput={this._handleTextChange}
          dataSource={this.state.projects.map(project => ({
            text: project.name,
            value: project.id
          }))}
        />
        <IconButton onClick={this._onClear}>
          <ClearIcon />
        </IconButton>
      </div>
    );
  }
}

ProjectSelector.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func,
  onSelect: PropTypes.func
};

export default ProjectSelector;



// WEBPACK FOOTER //
// ./src/components/ProjectSelector.js